var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBrush({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91753 8.24081L15.6654 2.85064L16.8449 4.14655L10.7509 11.354L7.91753 8.24081ZM5.58742 8.65199L10.1228 13.6353C10.2166 13.7283 10.3292 13.8003 10.453 13.8466C10.5768 13.8929 10.709 13.9123 10.8409 13.9038C10.9727 13.8952 11.1013 13.8587 11.218 13.7967C11.3348 13.7348 11.437 13.6488 11.5181 13.5444L18.9694 4.73139C19.1179 4.56827 19.2019 4.35672 19.2058 4.1362C19.2098 3.91569 19.1333 3.70128 18.9908 3.53299L16.4778 0.771826C16.3236 0.614102 16.1173 0.517858 15.8974 0.501055C15.6775 0.484251 15.459 0.548036 15.2827 0.680506L5.80901 7.27134C5.69745 7.3422 5.6022 7.43593 5.52955 7.54634C5.4569 7.65674 5.4085 7.78131 5.38756 7.9118C5.36661 8.0423 5.3736 8.17575 5.40805 8.30334C5.44251 8.43094 5.50364 8.54977 5.58742 8.65199ZM0.793915 14.5277L6.41127 15.5L7.89041 14.1538L4.86151 10.8258L0.793915 14.5277Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBrush);
export default __webpack_public_path__ + "static/media/edit_brush.765bba2ff05d0d49a05e884e9c98f914.svg";
export { ForwardRef as ReactComponent };